module.exports = __webpack_public_path__ + "img/logo.a56fbb6f.png";